import React from 'react'

const ExtensiveCoverageIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 464.027 464.027"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#83d8f4"
                        d="M375.96 50.145C374.91 229.652 229.653 374.91 50.146 375.96c55.41 70.062 146.128 102.078 233.238 82.32 87.113-19.761 155.137-87.785 174.898-174.898 19.758-87.11-12.258-177.828-82.32-233.238zm0 0"
                        opacity={1}
                        data-original="#83d8f4"
                    />
                    <path
                        fill="#91dcf5"
                        d="M375.96 50.145C283.66-22.988 151.2-15.34 67.93 67.93c-83.27 83.27-90.918 215.73-17.785 308.03C229.652 374.91 374.91 229.653 375.96 50.146zm0 0"
                        opacity={1}
                        data-original="#91dcf5"
                        className=""
                    />
                    <path
                        fill="#00bb77"
                        d="M344.016 96.016c-17.68 8-27.438-1.438-40 8-15.52 11.68-21.758 41.921-8 64 9.738 15.554 27.199 19.457 46.914 23.761a326.594 326.594 0 0 0 32.8-131.09 65.895 65.895 0 0 1-31.714 35.329zm0 0"
                        opacity={1}
                        data-original="#00bb77"
                        className="hovered-path"
                    />
                    <path
                        fill="#00a468"
                        d="M378.488 52.129a62.04 62.04 0 0 1-2.793 8.559 326.59 326.59 0 0 1-32.797 131.09l1.118.238c27.441 6 38.082-6.72 64 0a97.631 97.631 0 0 1 32 16 74.392 74.392 0 0 1 23.64 35.113c.176-3.688.36-7.375.36-11.113a231.511 231.511 0 0 0-85.528-179.887zM224.016 328.016c15.84 17.52 20 47.12 8 64-9.758 13.761-23.118 9.039-32 24a42.21 42.21 0 0 0 0 40 35.785 35.785 0 0 0 4.394 6.312 234.558 234.558 0 0 0 27.606 1.688c84.601.023 162.5-46.024 203.273-120.153-14.55-9.734-37.281-22.613-59.273-23.847a98.241 98.241 0 0 0-64 16c-23.598 17.28-28.239 41.761-40 40-8.32-1.2-12.88-14.641-16-24-7.145-21.313-3.27-35.735-3.336-47.688a326.913 326.913 0 0 1-30.575 21.711 46.014 46.014 0 0 1 1.91 1.977zm0 0"
                        opacity={1}
                        data-original="#00a468"
                    />
                    <path
                        fill="#00bb77"
                        d="M248.016 288.016c-8.239-11.52-23.598-13.68-40-16-34.399-4.801-47.918 10-64 0a37.993 37.993 0 0 1-16-40c6.722-20.078 36.082-13.278 72-40 11.601-8.559 39.199-29.118 40-56 .8-26.32-24.88-33.84-32-64-3.094-12.993 2.68-42.871 17.312-71.758C139.207 2.69 61.535 52.664 23.618 130.023v.075a235.713 235.713 0 0 0 .398 85.918c4.882 32.242 9.359 61.52 32 88 9.922 11.68 25.199 29.441 48 32 25.28 2.8 58.64-13.36 64-16a49.336 49.336 0 0 1 24-8 45.605 45.605 0 0 1 30.09 14.023 326.913 326.913 0 0 0 30.574-21.71 26.563 26.563 0 0 0-4.664-16.313zm0 0"
                        opacity={1}
                        data-original="#00bb77"
                        className="hovered-path"
                    />
                    <path
                        fill="#ff5023"
                        d="M168.016 64.016c0 35.359-64 120-64 120s-39.918-52.801-56.72-92.399a76.572 76.572 0 0 1-7.28-27.601c0-35.344 28.656-64 64-64 35.347 0 64 28.656 64 64zm0 0"
                        opacity={1}
                        data-original="#ff5023"
                    />
                    <path
                        fill="#f1f2f2"
                        d="M128.016 56.016c0 13.254-10.746 24-24 24s-24-10.746-24-24 10.746-24 24-24 24 10.746 24 24zm0 0"
                        opacity={1}
                        data-original="#f1f2f2"
                    />
                    <path
                        fill="#ffcd00"
                        d="M408.016 280.016a108.304 108.304 0 0 1-14.32 42.48 640.934 640.934 0 0 1-49.68 77.52s-20.961-27.758-38.961-58.16a305.819 305.819 0 0 1-17.758-34.239 76.572 76.572 0 0 1-7.281-27.601c0-35.344 28.656-64 64-64 35.347 0 64 28.656 64 64zm0 0"
                        opacity={1}
                        data-original="#ffcd00"
                    />
                    <path
                        fill="#f1f2f2"
                        d="M368.016 272.016c0 13.254-10.746 24-24 24s-24-10.746-24-24 10.746-24 24-24 24 10.746 24 24zm0 0"
                        opacity={1}
                        data-original="#f1f2f2"
                    />
                </g>
            </svg>

        </>
    )
}

export default ExtensiveCoverageIcon